import React, { useEffect, useState } from "react";
import API from "../services/api";

// Current App Version (Should match package.json)
const CURRENT_VERSION = "0.1.0";

const UpdateModal = () => {
    const [updateInfo, setUpdateInfo] = useState(null);
    const [show, setShow] = useState(false);

    useEffect(() => {
        // 🔴 DON'T show update modal on Admin pages (Flexible check for dash or space)
        const path = window.location.pathname.toLowerCase();
        if (path.includes("super") && path.includes("admin")) {
            return;
        }

        const checkUpdate = async () => {
            try {
                // Using the public endpoint we just created
                const res = await API.get("/app-settings");
                console.log("📱 App Settings Fetched:", res.data);
                const { latest_version, update_url, is_force_update, message } = res.data;

                console.log(`🔍 Version Check: Current(${CURRENT_VERSION}) vs Latest(${latest_version})`);

                if (latest_version && latest_version !== CURRENT_VERSION) {
                    setUpdateInfo({ url: update_url, force: is_force_update, msg: message });
                    setShow(true);
                }
            } catch (err) {
                console.error("Update check failed:", err);
            }
        };

        // Check on mount
        checkUpdate();
    }, []);

    if (!show || !updateInfo) return null;

    return (
        <div style={{
            position: "fixed",
            inset: 0,
            zIndex: 9999999,
            backgroundColor: "rgba(0,0,0,0.85)",
            backdropFilter: "blur(10px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px"
        }}>
            <div style={{
                background: "#1e2128",
                width: "100%",
                maxWidth: "360px",
                borderRadius: "32px",
                border: "1px solid rgba(255,255,255,0.1)",
                overflow: "hidden",
                boxShadow: "0 25px 50px -12px rgba(0,0,0,0.5)",
                textAlign: "center",
                padding: "32px 24px"
            }}>
                <div style={{
                    fontSize: "60px",
                    marginBottom: "20px",
                    animation: "bounce 2s infinite"
                }}>🚀</div>
                
                <h2 style={{
                    color: "white",
                    fontSize: "22px",
                    fontWeight: "900",
                    marginBottom: "12px",
                    textTransform: "uppercase",
                    letterSpacing: "1px"
                }}>New Update Available!</h2>
                
                <p style={{
                    color: "rgba(255,255,255,0.6)",
                    fontSize: "13px",
                    lineHeight: "1.6",
                    marginBottom: "32px"
                }}>
                    {updateInfo.msg || "A new version of WinroX11 is ready. Update now for better performance and new features."}
                </p>

                <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                    <button 
                        onClick={() => window.location.href = updateInfo.url}
                        style={{
                            background: "#ec4899", // Accent color
                            color: "white",
                            border: "none",
                            borderRadius: "16px",
                            padding: "16px",
                            fontSize: "14px",
                            fontWeight: "800",
                            textTransform: "uppercase",
                            letterSpacing: "1px",
                            cursor: "pointer",
                            boxShadow: "0 10px 20px rgba(236, 72, 153, 0.3)"
                        }}
                    >
                        Update Now
                    </button>

                    {!updateInfo.force && (
                        <button 
                            onClick={() => setShow(false)}
                            style={{
                                background: "transparent",
                                color: "rgba(255,255,255,0.4)",
                                border: "none",
                                fontSize: "11px",
                                fontWeight: "700",
                                textTransform: "uppercase",
                                cursor: "pointer",
                                marginTop: "8px"
                            }}
                        >
                            Maybe Later
                        </button>
                    )}
                </div>
            </div>
            <style>{`
                @keyframes bounce {
                    0%, 20%, 50%, 80%, 100% {transform: translateY(0);}
                    40% {transform: translateY(-20px);}
                    60% {transform: translateY(-10px);}
                }
            `}</style>
        </div>
    );
};

export default UpdateModal;
